import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/**
 * Wait for a given object which is calculated through a callback.
 */
function waitObject(_x) {
  return _waitObject.apply(this, arguments);
}

function _waitObject() {
  _waitObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getObject) {
    var delayNextCheck,
        maxTries,
        i,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            delayNextCheck = _args.length > 1 && _args[1] !== undefined ? _args[1] : 500;
            maxTries = _args.length > 2 && _args[2] !== undefined ? _args[2] : 0;
            i = 0;

          case 3:
            if (getObject()) {
              _context.next = 11;
              break;
            }

            if (!(maxTries > 0 && i >= maxTries)) {
              _context.next = 6;
              break;
            }

            return _context.abrupt("return", undefined);

          case 6:
            _context.next = 8;
            return new Promise(function (r) {
              return setTimeout(r, delayNextCheck);
            });

          case 8:
            i++;
            _context.next = 3;
            break;

          case 11:
            return _context.abrupt("return", getObject());

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _waitObject.apply(this, arguments);
}

export { waitObject };